import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { setAuthToken } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      // Store token in memory (httpOnly cookies handle server-side auth)
      setAuthToken(data.token);
      // Store non-sensitive user info for UI display only
      sessionStorage.setItem("admin_user", JSON.stringify({ id: data.id, name: data.name, role: data.role }));
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      const errorMessage = getErrorMessage(detail);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const getErrorMessage = (detail) => {
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
    return "Login failed";
  };

  return (
    <div className="min-h-screen bg-[#E8EDF5] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="font-heading font-black text-2xl text-[#1B2A4A]" data-testid="admin-login-title">Admin Login</h1>
          <p className="text-sm text-[#1B2A4A]/60 mt-1">Dr. Ben Magee CMS</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white rounded-sm border border-[#1B2A4A]/10 p-8 space-y-5">
          <div>
            <Label className="text-[#1B2A4A] text-sm mb-1.5 block">Email</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" className="rounded-sm border-[#1B2A4A]/20" autoComplete="email" />
          </div>
          <div>
            <Label className="text-[#1B2A4A] text-sm mb-1.5 block">Password</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" className="rounded-sm border-[#1B2A4A]/20" autoComplete="current-password" />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
          <Button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full bg-[#C9A84C] text-[#1B2A4A] hover:bg-[#b59744] hover:text-white font-semibold rounded-sm">
            {loading ? "Logging in..." : "Log In"}
          </Button>
        </form>
        <p className="text-center mt-4">
          <a href="/" className="text-sm text-[#1B2A4A]/60 hover:text-[#C9A84C]">Back to site</a>
        </p>
      </div>
    </div>
  );
}
